import {useCallback, useEffect, useState} from "react";
import {useSnackbarContext} from "../../common/Snackbar";
import {findHubs} from "../../../api/HubApi";

export default function UseHubList() {
    const [hubs, setHubs] = useState([]);
    const [hubsLoading, setHubsLoading] = useState(false);

    const {handleMessageUpdate} = useSnackbarContext();

    function handleApiError(error) {
        handleMessageUpdate(`${error.message} [${error.code}]`);
    }

    const handleErrorCallback = useCallback(handleApiError, []);

    useEffect(() => {
        function handleHubsChange(hubs) {
            setHubs(hubs)
        }

        function handleHubsLoadingChange(loading) {
            setHubsLoading(loading);
        }

        handleHubsLoadingChange(true);

        findHubs()
            .then(hubs => {
                handleHubsChange(hubs);
                handleHubsLoadingChange(false);
            })
            .catch((error) => {
                handleHubsLoadingChange(false);
                handleErrorCallback(error);
            });
    }, [handleErrorCallback]);

    return {hubs, hubsLoading};
}